// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".graphic-page-graphicPageContainer--3NT8grLBG8uxWK6LH8yQEw{display:flex;flex-flow:column;height:calc(100vh - 108px)}", "",{"version":3,"sources":["webpack://src/pages/Graphic/graphicPage.module.scss"],"names":[],"mappings":"AAAA,2DACC,YAAA,CACA,gBAAA,CACA,0BAAA","sourcesContent":[".graphicPageContainer {\r\n\tdisplay: flex;\r\n\tflex-flow: column;\r\n\theight: calc(100vh - 108px);\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"graphicPageContainer": "graphic-page-graphicPageContainer--3NT8grLBG8uxWK6LH8yQEw"
};
export default ___CSS_LOADER_EXPORT___;
